import { type ReactNode, useRef, forwardRef } from "react";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { colorsSelector } from "@redux/colorPalette/selectors";
import { useSelector } from "react-redux";

import { ButtonContainer } from "./ScrollButton.style";

interface IScrollButton {
	children: ReactNode;
	scrollDown: () => void;
	scrollUp: () => void;
}

const ScrollButton = forwardRef<HTMLDivElement, IScrollButton>(
	({ children, scrollDown, scrollUp }) => {
		const colors = useSelector(colorsSelector);
		const sectionTopRef = useRef<HTMLDivElement>(null);
		const sectionBottomRef = useRef<HTMLDivElement>(null);

		return (
			<>
				<ButtonContainer
					ref={sectionTopRef}
					onClick={scrollDown}
					{...{ colors }}
					top
				>
					<ExpandMoreIcon />
				</ButtonContainer>
				{children}
				<ButtonContainer
					ref={sectionBottomRef}
					onClick={scrollUp}
					{...{ colors }}
				>
					<ExpandLessIcon />
				</ButtonContainer>
			</>
		);
	},
);

export default ScrollButton;
